<template>
  <v-row>
    <v-col>
      <v-col
        class="d-flex justify-space-between mx-auto py-5 flex-wrap container"
      >
        <ToolbarTitles :title="title" />
      </v-col>

      <TableWithFilters
        :items="licensesAll"
        :headers="allHeaders"
        :openDialog="openDialog"
        :showRefresh="true"
        @headersUpdated="updateHeaders"
        @refreshItems="refreshItems"
        class="container"
      />
      <v-dialog
        v-model="open"
        persistent
        @keydown.esc="reset()"
        max-width="2000px"
        permanent
      >
        <v-card
          v-if="
            mode === $t('licenses.addLicense') ||
            mode === $t('licenses.editLicense')
          "
        >
          <v-card-title class="d-flex justify-center">{{ mode }}</v-card-title>

          <div class="mx-4">
            <v-alert
              v-if="alertCSV"
              type="error"
              color="deep-orange"
              dense
              outlined
              :value="alertCSV"
              height="80px"
              max-width="800px"
              class="mx-auto"
              style="overflow-y: scroll; scrollbar-width: unset"
            >
              {{ textAlertCSV }}
              <ul>
                <li v-for="(error, index) in errors" :key="index">
                  {{ error }}
                </li>
              </ul>
            </v-alert>
            <v-text-field
              ref="name"
              dense
              outlined
              :label="$tc('licenses.nameLicense')"
              v-model="name.value"
              :rules="[validateRequired]"
            />
            <v-switch
              v-if="mode === $t('licenses.editLicense')"
              v-model="status.value"
              :disabled="!status.state"
              inset
              class="ma-0 mb-5"
              hide-details
              :label="
                status.value
                  ? $tc('licenses.finished')
                  : $tc('licenses.pending')
              "
            ></v-switch>

            <div v-if="mode === $t('licenses.addLicense')">
              <input type="file" accept=".csv" @change="handleFileUpload" />
            </div>
            <v-data-table
              v-if="csvData.length > 0"
              :headers="csvHeaders"
              :items="csvData"
              item-value="legajo"
              height="300px"
              fixed-header
              :item-class="getRowClass"
              class="elevation-1"
              :hide-default-footer="true"
              disable-pagination
            >
              <template v-slot:item.legajo="{ item }">
                <v-text-field
                  v-if="editableRow === item.liId"
                  v-model="item.legajo"
                  dense
                  :rules="[validateRequired]"
                />
                <span v-else>{{ item.legajo }}</span>
              </template>

              <template v-slot:item.ent="{ item }">
                <v-text-field
                  v-if="editableRow === item.liId"
                  v-model="item.ent"
                  dense
                  :rules="[validateRequired, validateDateTime]"
                  placeholder="YYYY-MM-DD HH:MM"
                />
                <span v-else>{{ item.ent }}</span>
              </template>

              <template v-slot:item.sal="{ item }">
                <v-text-field
                  v-if="editableRow === item.liId"
                  v-model="item.sal"
                  dense
                  :rules="[validateRequired, validateDateTime]"
                  placeholder="YYYY-MM-DD HH:MM"
                />
                <span v-else>{{ item.sal }}</span>
              </template>
              <template v-slot:item.concepto="{ item }">
                <v-text-field
                  v-if="editableRow === item.liId"
                  v-model="item.concepto"
                  dense
                  :rules="[validateRequired]"
                />
                <span v-else>{{ item.concepto }}</span>
              </template>
              <template v-slot:item.observaciones="{ item }">
                <v-text-field
                  v-if="editableRow === item.liId"
                  v-model="item.observaciones"
                  dense
                />
                <span v-else>{{ item.observaciones }}</span>
              </template>

              <template v-slot:item.actions="{ item }">
                <div class="d-flex justify-lg-space-between">
                  <v-btn
                    v-if="editableRow !== item.liId"
                    icon
                    @click="setEditableRow(item.liId)"
                  >
                    <v-icon color="primary">mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="editableRow === item.liId"
                    icon
                    @click="cancelEdit(item)"
                  >
                    <v-icon color="grey">mdi-cancel</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="editableRow === item.liId"
                    icon
                    @click="saveEdit(item)"
                  >
                    <v-icon color="green">mdi-content-save</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="editableRow !== item.liId"
                    icon
                    @click="deleteDetail(item)"
                  >
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>

            <div class="d-flex justify-space-between py-4">
              <v-btn class="bt-exit" @click="reset">{{
                $tc("commons.cancel")
              }}</v-btn>
              <v-btn
                class="bt-acept"
                text
                @click="saveCSV"
                v-if="mode === $t('licenses.addLicense')"
                >{{ $tc("commons.accept") }}</v-btn
              >
              <v-btn
                class="bt-acept"
                text
                @click="saveEditLicense"
                v-if="mode === $t('licenses.editLicense')"
              >
                {{ $tc("commons.accept") }}</v-btn
              >
            </div>
          </div>
        </v-card>
      </v-dialog>

      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
      <DeleteDialog
        :showDialog="showDeleteDetailDialog"
        :title="titleDetailDelete"
        :confirmDelete="confirmDeleteDetail"
        :cancelDelete="cancelDeleteDetail"
      />
      <Snackbar :alert="alert" :textAlert="textAlert" :color="color" />
      <v-dialog
        v-model="isLoading"
        class="dialog__loader"
        :overlay-opacity="0.3"
      >
        <Loader :loading="isLoading" />
      </v-dialog>
    </v-col>
  </v-row>
</template>
<script>
import licenses from "../../../store/cargaDeLicencias/licenses";
import TableWithFilters from "./commons/TableWithFilters.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import Loader from "@/components/Complement/Loader.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    TableWithFilters,
    Snackbar,
    DeleteDialog,
    ToolbarTitles,
    Loader,
  },
  data() {
    return {
      title: this.$tc("licenses.licenses"),
      titleTable:this.$tc("licenses.licenses"),
      isLoading: false,
      name: {
        value: null,
        state: null,
      },
      status: {
        value: null,
        state: null,
      },
      csvData: [],
      alertCSV: false,
      textAlertCSV: "",
      errors: [],
      editableRow: null,
      titleDelete: this.$tc("licenses.toLicense"),
      itemToDelete: null,
      titleDetailDelete: this.$tc("licenses.toLicenseDetail"),
      showDeleteDetailDialog: false,
      detailToDelete: null,
      filters: {
        orderby: null, // Campo de ordenación
        where: {
          procId: "",
          nombre: "",
          estado: "",
        }, // Filtros dinámicos
      },
      headers: [
        {
          text: "ID",
          value: "procId",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Estado",
          value: "statusIcon",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Fecha de creación",
          value: "fechaI",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Fecha de última actualización",
          value: "fechaU",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          width: "100px",
        },
      ],
      showDelete: false,
      itemDelete: null,
      alert: false,
      textAlert: "",
      color: "#82A1D0",
      key: 0,
      formValid: false,
    };
  },
  async mounted() {
    this.isLoading = true;
    await licenses
      .dispatch("getLicenses", { limit: 50, order: "procId desc" })
      .then(() => {
        this.isLoading = false;
      });
       configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (configTable.state.colums.length === 0 || configTable.state.colums.length !== this.headers.length ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
  },
  computed: {
     allHeaders() {
      return Array.isArray(configTable.state?.colums)
        ? configTable.state.colums
        : [];
    },
    licensesAll() {
      return licenses.state.licenses;
    },
    mode() {
      return licenses.state.mode;
    },
    open: {
      get() {
        return licenses.state.open;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return licenses.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    csvHeaders() {
      const commonHeaders = [
        { text: "Legajo", value: "legajo", class: "primary secondary--text" },
        {
          text: "Concepto",
          value: "concepto",
          class: "primary secondary--text",
        },
        {
          text: "Observaciones",
          value: "observaciones",
          class: "primary secondary--text",
        },
      ];

      // Encabezados específicos según el modo
      if (this.mode === this.$t("licenses.editLicense")) {
        return [
          ...commonHeaders,
          { text: "Entrada", value: "ent", class: "primary secondary--text" },
          { text: "Salida", value: "sal", class: "primary secondary--text" },
          {
            text: "Estado formato",
            value: "stFormatoIcon",
            class: "primary secondary--text",
          },
          {
            text: "Mensaje del formato",
            value: "msgFormato",
            class: "primary secondary--text",
          },
          {
            text: "Acciones",
            value: "actions",
            class: "primary secondary--text",
          },
        ];
      } else {
        // Si el modo es 'add', usar los formatos legibles
        return [
          ...commonHeaders,
          {
            text: "Entrada",
            value: "entFormatted",
            class: "primary secondary--text",
          },
          {
            text: "Salida",
            value: "salFormatted",
            class: "primary secondary--text",
          },
        ];
      }
    },
  },

  methods: {
    async refreshItems() {
      await licenses.dispatch("getLicenses", {
        limit: 50,
        order: "procId desc",
      });
    },
     updateHeaders(headers) {
      const updatedColums = headers;

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = this.allHeaders;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }
      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };

      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    async allItems() {
      await licenses.dispatch("getLicenses");
    },
    getRowClass(item) {
      // Verifica si item.stFormato tiene un valor válido
      if (item.stFormato) {
        return "green-background";
      } else if (item.stFormato === undefined || item.stFormato === null) {
        // Si no tiene valor, no aplica ninguna clase
        return "";
      }
      // En caso de que `item.stFormato` teng a un valor pero no sea `true`, puedes especificar otra clase si es necesario
      return "red-background";
    },
    setEditableRow(liId) {
      this.editableRow = liId;
    },
    cancelEdit() {
      this.editableRow = null;
    },
    saveEdit(item) {
      let payload = {
        ...item,
        procId: licenses.state.edit.procId,
      };
      licenses.commit("setEditDetail", payload);
      licenses
        .dispatch("editDetail")
        .then(() => {
          licenses.dispatch("getLicenceDetails").then(() => {
            this.csvData = licenses.state?.license;
          });
          this.editableRow = null;

          this.showSnackbar(this.$tc("licenses.editLicenseSuccess"));
        })
        .catch((e) => {
          this.showSnackbar(e.response.data.error.message, "#ff8d58");
        });
    },
    deleteDetail(item) {
      let payload = {
        procId: licenses.state.edit.procId,
        liId: item.liId,
      };
      this.detailToDelete = payload;
      licenses.commit("setDeleteItemDetail", payload);
      this.showDeleteDetailDialog = true;
    },
    confirmDeleteDetail() {
      licenses
        .dispatch("deleteDetail")
        .then(() => {
          this.csvData = licenses.state?.license;
          this.cancelDeleteDetail();
          this.showSnackbar(this.$tc("licenses.deleteDetailSuccess"));
        })
        .catch((e) => {
          this.showSnackbar(e.response.data.error.message, "#ff8d58");
        });
    },
    cancelDeleteDetail() {
      this.detailToDelete = null;
      this.showDeleteDetailDialog = false;
    },
    confirmDelete() {
      this.csvData = this.csvData.filter(
        (row) => row.legajo !== this.itemToDelete.legajo
      );
      this.itemToDelete = null;
      this.showDelete = false;
    },
    cancelDelete() {
      this.itemToDelete = null;
      this.showDelete = false;
    },
    async openDialog(type, item) {
      this.typeForm = type;
      switch (this.typeForm) {
        case "add":
          licenses.commit("setMode", this.$tc("licenses.addLicense"));
          licenses.commit("setOpen", true);
          break;
        case "edit":
          await licenses.commit("setMode", this.$tc("licenses.editLicense"));
          this.itemId = item.procId;
          licenses.commit("setEdit", item);
          await licenses.dispatch("getLicenceDetails").then(() => {
            this.csvData = licenses.state?.license;
          });
          this.name.value = licenses.state.edit?.name;
          this.name.state = licenses.state.edit?.name;
          this.status.value = licenses.state.edit?.status === "T";
          this.status.state = licenses.state.edit?.status === "T";
          licenses.commit("setOpen", true);
          break;
        case "delete":
          licenses.commit("setDeleteItem", item.procId);
          licenses.commit("setOpenDelete", true);
          break;
        case "process":
          this.isLoading = true;
          licenses.dispatch("process", item).then(() => {
            this.isLoading = false;
            this.alert;
          });
        case "allLicenses":
          this.isLoading = true;
          licenses.dispatch("getLicenses").then(() => {
            this.isLoading = false;
          });
        default:
          break;
      }
    },

    reset() {
      this.name.value = null;
      this.name.state = null;
      this.status.value = null;
      this.status.state = null;
      this.csvData = [];
      this.errors = [];
      licenses.commit("setOpen", false);
      this.$refs.name.resetValidation();
    },
    deleteItem() {
      licenses
        .dispatch("delete")
        .then(() => {
          this.openDelete = false;
          licenses.commit("setOpenDelete", false);
          this.showSnackbar(this.$tc("licenses.deleteLicenseSuccess"));
        })
        .catch((e) => {
          this.showSnackbar(e.response.data.error.message, "#ff8d58");
        });
    },
    cancelDelete() {
      this.openDelete = false;
      licenses.commit("setOpenDelete", false);
    },
    async handleFileUpload(event) {
      // Limpiar los errores y datos previos
      this.errors = [];
      this.csvData = [];
      this.alertCSV = false;

      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const csv = e.target.result;
          try {
            const parsedData = await this.processCSV(csv);
            if (this.errors.length > 0) {
              // Si hay errores, mostrar alerta
              this.alertCSV = true;
              this.textAlertCSV = `Se encontraron errores en el archivo.`;
            }
          } catch (error) {
            console.error("Error al procesar el archivo:", error.message);
            this.alertCSV = true;
            this.textAlertCSV = "Error al procesar el archivo.";
          }
        };
        reader.readAsText(file);
      }
    },

    processCSV(data) {
      return new Promise((resolve, reject) => {
        try {
          const parsedData = this.parseCSV(data); // Parsear el CSV
          this.csvData = parsedData; // Guardar los datos parseados
          resolve(parsedData); // Retornar los datos
        } catch (error) {
          reject(error); // Retornar el error en caso de fallo
        }
      });
    },

    parseCSV(data) {
      const lines = data.split("\n");
      const result = [];
      const requiredFields = ["legajo", "ent", "sal", "concepto"];
      const datePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/; // Patrón para validar fechas ISO

      for (let i = 1; i < lines.length; i++) {
        const currentLine = lines[i].split(",");
        if (currentLine.length === 5) {
          const entry = {
            legajo: currentLine[0],
            ent: currentLine[1],
            sal: currentLine[2],
            concepto: currentLine[3],
            observaciones: currentLine[4],
          };

          // Inicializar stFormato como true
          entry.stFormato = true;

          // Validar si los campos requeridos están vacíos
          requiredFields.forEach((field) => {
            if (!entry[field]) {
              this.errors.push(
                `Error en la fila ${i + 1}: El campo '${field}' es requerido.`
              );
              entry.stFormato = false; // Marcar como inválido
            }
          });

          // Validar el formato de las fechas
          if (!datePattern.test(entry.ent)) {
            this.errors.push(
              `Error en la fila ${
                i + 1
              }: Formato de fecha de entrada incorrecto.`
            );
            entry.stFormato = false; // Marcar como inválido
          } else {
            // Convertir la fecha de entrada a el formato deseado y almacenarla en una nueva variable
            const dateEnt = new Date(entry.ent);
            entry.entFormatted = dateEnt
              .toISOString()
              .slice(0, 19)
              .replace("T", " "); // Formato yyyy-mm-dd hh:mm
          }

          if (!datePattern.test(entry.sal)) {
            this.errors.push(
              `Error en la fila ${
                i + 1
              }: Formato de fecha de salida incorrecto.`
            );
            entry.stFormato = false; // Marcar como inválido
          } else {
            // Convertir la fecha de salida a el formato deseado y almacenarla en una nueva variable
            const dateSal = new Date(entry.sal);
            entry.salFormatted = dateSal
              .toISOString()
              .slice(0, 19)
              .replace("T", " "); // Formato yyyy-mm-dd hh:mm
          }

          result.push(entry);
        }
      }

      return result; // Retornar los datos parseados
    },
    saveCSV() {
      // Preparar el payload sin entFormatted y salFormatted
      let payload = {
        nombre: this.name.value,
        detalles: this.csvData.map((item) => ({
          legajo: item.legajo,
          ent: item.ent, // Mantener el valor original de entrada
          sal: item.sal, // Mantener el valor original de salida
          concepto: item.concepto,
          observaciones: item.observaciones,
        })),
      };

      licenses.commit("setNew", payload);
      licenses
        .dispatch("new")
        .then(() => {
          this.reset();
          this.showSnackbar(this.$tc("licenses.addLicenseSuccess"));
        })
        .catch((e) => {
          this.reset();
          this.showSnackbar(e.response.data.error.message, "#ff8d58");
        });
    },
    validateRequired(value) {
      return !!value || "Este campo es requerido";
    },
    validateDateTime(value) {
      const dateTimePattern = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/;
      return (
        dateTimePattern.test(value) ||
        'Debe estar en formato "YYYY-MM-DD HH:MM"'
      );
    },
    handleSave(item) {
      if (
        !this.validateDateTime(item.ent) ||
        !this.validateDateTime(item.sal)
      ) {
        this.$emit(
          "show-error",
          'Fecha y hora deben estar en formato "YYYY-MM-DD HH:MM".'
        );
        return;
      }
      this.saveEdit(item);
    },
    saveEditLicense() {
      let payload = {
        procId: licenses.state.edit.procId,
        nombre:
          this.name.value === this.name.state ? undefined : this.name.value,
        estado:
          this.status.value === this.status.state
            ? undefined
            : this.status.value,
      };

      // Verifica si ambos campos son undefined
      if (payload.nombre === undefined && payload.estado === undefined) {
        return; // Salir de la función si no hay cambios
      }
      licenses.commit("setEditLicense", payload);
      licenses
        .dispatch("edit")
        .then(() => {
          this.reset();
          this.showSnackbar(this.$tc("licenses.editLicenseSuccess"));
        })
        .catch((e) => {
          this.reset();
          this.showSnackbar(e.response.data.error.message, "#ff8d58");
        });
    },
    showSnackbar(title, color) {
      this.alert = true;
      this.textAlert = title;
      this.color = color || this.color; // Si no se pasa un color, usa el color por defecto en this.color

      // Oculta el snackbar después de 3 segundos (o el tiempo que prefieras)
      setTimeout(() => {
        this.alert = false;
      }, 3000); // 3000 milisegundos = 3 segundos
    },
  },
};
</script>
<style scoped>
.container {
  max-width: 100%;
  padding-top: 1vh;
  padding-bottom: 1vh;
}
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
::v-deep
  .v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.red-background {
  background-color: #ffcccc !important; /* Rojo claro para filas con la clase 'red-background' */
}
::v-deep
  .v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.green-background {
  background-color: #ccffcc !important; /* Verde claro para filas con la clase 'green-background' */
}

.elevation-1 {
  border: 1px solid #ccc;
  border-radius: 4px;
}
::v-deep .v-data-table--fixed-header > .v-data-table__wrapper {
  overflow-y: scroll;
  scrollbar-width: unset;
}
</style>
